import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Arrow } from "@faire/web--source/slate/icons/foundation/Arrow";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";
export var maybeAddCTATile = function(arr, data, itemsPerSlide) {
    if (shouldAddCTATile(arr, data, itemsPerSlide) && isNotUndefined(data)) {
        return _to_consumable_array(arr).concat([
            /*#__PURE__*/ _jsx(CTATile, {
                data: data
            }, "cta-tile")
        ]);
    } else {
        return arr;
    }
};
var shouldAddCTATile = function(arr, data, itemsPerSlide) {
    return isNotUndefined(data) && (arr.length > itemsPerSlide || data.alwaysVisible);
};
export var CTATile = function(param) {
    var data = param.data;
    return /*#__PURE__*/ _jsxs(TileWrapper, {
        to: data.linkTo,
        onClick: data.onClick,
        "data-test-id": "cta-tile-wrapper",
        children: [
            /*#__PURE__*/ _jsx(IconWrapper, {
                children: /*#__PURE__*/ _jsx(Arrow, {
                    direction: "right",
                    fontSize: "32px"
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansMedium",
                align: "center",
                children: data.text
            })
        ]
    });
};
var TileWrapper = styled(Link).withConfig({
    componentId: "sc-f4d3f39c-0"
})([
    "display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;padding:",
    ";"
], getSpacing("2x"));
var IconWrapper = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-f4d3f39c-1"
})([
    "background:",
    ";width:",
    ";height:",
    ";border-radius:50%;"
], Core.surface.subdued, getSpacing("7x"), getSpacing("7x"));
